import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import {ThemeToggleButtonComponent} from '../../../shared/components/theme-toggle/theme-toggle-button.component';

@Component({
  selector: 'app-not-found',
  imports: [
    RouterModule,
    ThemeToggleButtonComponent,
  ],
  templateUrl: './not-found.component.html',
  styles: ``
})
export class NotFoundComponent {

  currentYear: number = new Date().getFullYear();
}
